<template>
  <div class="workorder">

    <!-- Loading Animation START 
    [[ This is the loading animation that is activated while the work orders are loading, either by the initial load or after refreshing the work order list. This shows when (loadingWorkOrders == true) ]] -->
    <div v-if="busy" class="full-box">
     <div class="loadingWorkOrders">
        <div class="logo"></div>
        <div class="loading-image"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"></i></div>
        Loading Work Order #{{this.$route.params.id}}           
      </div>
    </div>
    <!-- Loading Animation END -->  

    <!-- Mobile Menu START 
    [[ Mobile menu that comes out from the side, when you click on the menu button in the header. This shows when (openMenu == true) ]] -->
    <template v-if="openMenu">
      <div class="overlay">
        <div class="mobile-menu">
          <div class="inner">
            <div v-on:click="hideMenu()" class="close-menu"><i class="fa fa-times" aria-hidden="true"></i></div>
            <h2 class="mcText">{{username}}</h2>
            <ul>
              <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
              <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
            </ul><br><br>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Menu END -->
    
    <div class="main-header">
      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">

            <!-- Tablet Header START 
            [[ Includes the ability to go back to the Work Order listings ]] -->
            <div v-if="$mq.resize && $mq.above($mv.tablet)">
              <button v-on:click="backToListings()" class="pull-right btn header-btn mcBG scBGHover"><i class="fa fa-reply" aria-hidden="true"></i> Back to Listings</button>
            </div>
            <!-- Tablet Header END -->

            <!-- Mobile Header START 
            [[ Includes the ability to go back to the Work Order listings & to show the menu ]] -->
            <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
              <ul>
                <li v-on:click="backToListings()"><i class="fa fa-reply" aria-hidden="true"></i></li>
                <li v-on:click="showMenu()"><i class="fa fa-bars" aria-hidden="true"></i></li>
              </ul>
            </div>
            <!-- Mobile Header END -->

            <div class="logo"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Main Header END -->

      <!-- Header Bar START -->
      <div class="inner-header-bar mcBG">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <img src="static/img/i3v_icon_white.png" class="pull-right">
                <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
                  <h1>WO# {{workOrder.woNumber}}</h1>
                </div>
                <div v-if="$mq.resize && $mq.above($mv.tablet)">
                  <h1>My Work Orders </h1>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Bar END -->

    <!-- Main Tablet View START 
    [[ Everything starting from now is what's seen in desktop/tablet mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is less than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.above($mv.tablet)" class="tablet-view">
      <div class="container">
        
        <div class="row flexrow">

          <!-- Work Order Info START 
          [[ These are all the fields and information from the current work order. ]] -->
          <div class="col-sm-5">
            <div class="inner">
              <h2>WO# {{workOrder.woNumber}}</h2>
              <ul class="innerWOListing">
                <li><strong class="scText">Address:</strong> {{workOrder.situsNum}} {{workOrder.situsLabel}}</li>
                <li><strong class="scText">Contact Phone #:</strong> <a id="link"> {{workOrder.phone}}</a> </li>
                <li><strong class="scText">City:</strong> {{workOrder.city}} </li>
                <li><strong class="scText">Generated Date:</strong> {{workOrder.generatedDate | moment("MMM Do, YYYY") }}</li>
                <li><strong class="scText">Scheduled Date: </strong> {{workOrder.scheduledDate | moment("MMM Do, YYYY") }} </li>
                <li><strong class="scText">District:</strong> {{workOrder.districtCode}} | {{workOrder.districtName}}</li>
                <li><strong class="scText">Lot:</strong> {{workOrder.lot}} | <strong class="scText">Block:</strong> {{workOrder.block}} | <strong class="scText">Section: </strong> {{workOrder.section}}</li>
                <li><strong class="scText">Subdivision:</strong> {{workOrder.subdivision}}</li>
                <li><strong class="scText">Problem:</strong> {{workOrder.problemDescription}}</li>
                <li><strong class="scText">UCC#:</strong> {{workOrder.ucc}} </li>
                <li><strong class="scText">Priority: </strong> {{workOrder.priority}} </li>
                <li><strong class="scText">Prepared By:</strong> {{workOrder.preparedBy}} </li>
                <li><strong class="scText">Comments:</strong> {{workOrder.woComments}} </li>
                <li><strong class="scText">Meter #:</strong> {{workOrder.meterNumber}} </li>
                <li><strong class="scText">MTU #:</strong> {{workOrder.mtuNumber}} </li>
                <li><strong class="scText">Current Meter Read:</strong> {{workOrder.currentMeterRead}} </li>
                <li><strong class="scText">Previous Meter Read:</strong> {{workOrder.previousMeterRead}} </li>
              </ul>  
            </div>
          </div>
          <!-- Work Order Info END --> 

          <!-- Work Order Actions START 
          [[ These are all the actions to add LEMs and to close the Work Order. ]] -->
          <div class="col-sm-4">
            <div class="inner">
              <h2>Actions</h2>
              <ul class="innerWOActions">
                <li class="scTextHover" v-on:click="enterLabor()"><i class="fa fa-user-circle" aria-hidden="true"></i> Labor ({{ laborRecords.length }})</li>
                <li class="scTextHover" v-on:click="enterEquipment()"><i class="fa fa-truck" aria-hidden="true"></i> Equipment ({{ equipRecords.length }})</li>
                <li class="scTextHover" v-on:click="enterMaterial()"><i class="fa fa-wrench" aria-hidden="true"></i> Materials ({{ materialRecords.length }})</li>
                <li class="scTextHover" v-on:click="enterNotes()"><i class="fa fa-comments-o" aria-hidden="true"></i> Internal Notes ({{ notesRecords.length }})</li>
                <li class="scTextHover" v-if="this.canUsePhotos" v-on:click="enterPhoto()"><i class="fa fa-picture-o" aria-hidden="true"></i> Photos ({{ photoRecords.length }})</li>
                <li class="scTextHover" v-if="!workOrder.fieldComplete" v-on:click="openWOcloseForm()"><i class="fa fa-check-square" aria-hidden="true"></i> Close Work Order</li>
              </ul>

              <!-- Form to Close the WO START 
              [[ The following form is only shown if the Work Order is open. (workOrder.fieldComplete == false) ]] -->
              <div v-if="!workOrder.fieldComplete">
                <div class="closeWorkOrderContainer">
                  <div v-if="!this.openWOform" class="top"></div>
                <h2>Close Work Order</h2>
                <form @submit.prevent="close">
                  <div class="form-group">
                    <label for="solutioncode">Solution Code</label><br>
                    <el-select @change="changeDescription()" v-model="workOrder.solutionCode" popper-class="popClass" no-match-text="No Solution Code Found" filterable placeholder="Select a Solution Code">
                      <el-option class="form-control"
                        v-for="solution in orderBy(solutionCodes, 'description', 1)"
                        v-if="solution.department == workOrder.department"
                        :label="solution.description + ' (' + solution.solutionCode + ')'" 
                        :value="solution.solutionCode">
                      </el-option>
                    </el-select> 
                  </div>

                  <div class="form-group">
                    <label for="repairdescription">Description of Repairs / Field Notes</label>
                    <textarea name="repairdescription" class="form-control" v-model="workOrder.repairsDescription"></textarea> 
                  </div>

                  <div v-if="workOrder.solutionCode">
                    <div class="form-group">
                      <button type="submit" class="btn mcBG scBGHover">Complete & Close WO</button>
                    </div>  
                  </div>

                </form> 
                </div>
              </div>
              <!-- Form to Close the WO END -->          

              <!-- Completed Work Order Info START 
              [[ The following information is only shown if the Work Order is marked as completed. (workOrder.fieldComplete == true) ]] -->
              <div v-if="workOrder.fieldComplete">
                <h2>This Work Order is Closed</h2>
                <ul class="innerWOListing">
                <li><strong>Solution:</strong> <span class="inline-block" v-for="solution in solutionCodes" v-if="solution.solutionCode == workOrder.solutionCode">
                {{solution.description}}</span></li>
                <li><strong>Solution Code:</strong> {{workOrder.solutionCode}} </li>
                <li><strong>Completed Date:</strong> {{workOrder.completeDate | moment("MMM Do, YYYY") }} </li>
                <li><strong>Description of Repairs:</strong> {{workOrder.repairsDescription}} </li>
                </ul>
              </div>
              <!-- Completed Work Order Info END -->         

            </div>
          </div>

          <!-- Right Column START 
          [[ This is where we show the Menu ]] -->
          <div class="col-sm-3">
            <div class="inner-dark">
              <h3 class="mcText"><span>Username</span>
              {{username}}</h3>
              <ul>
                <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
                <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
              </ul><br><br>
            </div>
          </div>
          <!-- Right Column END -->

        </div>
      </div>
    </div>
    <!-- Main Tablet View END -->

    <!-- Main Mobile View START 
    [[ Everything starting from now is what's seen in mobile mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is more than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
      <div class="mobile-view">

        <!-- Top Mobile Info START 
        [[ The top two squares of info in the mobile view, Address and Date ]] -->
        <div class="innerWOtopRow">
          <div class="container">
            <div class="row">
              <div class="col-xs-6 left">
                <h5><i class="fa fa-map-marker" aria-hidden="true"></i> Address</h5>
                {{workOrder.situsNum}} {{workOrder.situsLabel}}
              </div>
              <div class="col-xs-6 right mcBG">
                <h5><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Generated</h5>
                {{workOrder.generatedDate | moment("MMM Do, YYYY") }}
                <h5><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Scheduled</h5>
                {{workOrder.scheduledDate | moment("MMM Do, YYYY") }}
              </div>
            </div>
          </div>
        </div>
        <!-- Top Mobile Info END -->

        <!-- Work Order Info START 
        [[ These are all the fields and information from the current work order. ]] -->
        <div class="innerWOmainListing">
          <p><strong>Contact Phone #:</strong> <a id="link">{{workOrder.phone}}</a></p>
          <p><strong>City:</strong> {{workOrder.city}} </p>
          <p><strong>District:</strong> {{workOrder.districtCode}} | {{workOrder.districtName}}</p>
          <p><strong>Lot:</strong> {{workOrder.lot}} | <strong class="scText">Block:</strong> {{workOrder.block}} | <strong class="scText">Section: </strong> {{workOrder.section}}</p>
          <p><strong>Problem:</strong> {{workOrder.problemDescription}}</p>
          <p v-bind:class="'priority' + workOrder.priority"><strong>Priority: </strong> {{workOrder.priority}}</p>
          <p><strong>Prep. By:</strong> {{workOrder.preparedBy}} | <strong>UCC#:</strong> {{workOrder.ucc}}</p>
          <p><strong>Comments:</strong> {{workOrder.woComments}}</p>
          <p><strong>Meter #:</strong> {{workOrder.meterNumber}}</p>
          <p><strong>MTU #:</strong> {{workOrder.mtuNumber}}</p>
          <p><strong>Current Read:</strong> {{workOrder.currentMeterRead}} | <strong>Previous Read:</strong> {{workOrder.previousMeterRead}}</p>
        </div>
        <!-- Work Order Info END -->

        <ul class="innerWOActions">
           <li v-on:click="enterNotes()"><i class="fa fa-comments-o" aria-hidden="true"></i> Internal Notes ({{ notesRecords.length }})</li>
           <li v-if="this.canUsePhotos" v-on:click="enterPhoto()"><i class="fa fa-picture-o" aria-hidden="true"></i> Photos ({{ photoRecords.length }})</li>
           <li v-if="!this.openWOform"  v-on:click="openWOcloseForm()"><i class="fa fa-check-square" aria-hidden="true"></i> Close Work Order</li>
        </ul>

        <!-- Form to Close the WO START 
        [[ The following form is only shown if the Work Order is open. (workOrder.fieldComplete == false) ]] -->
        <div v-if="!workOrder.fieldComplete">
          <div v-if="this.openWOform">
            <div class="innerWoCompletion">
              
              <div class="form-group">
                <label for="solutioncode">Solution Code</label>
                <el-select @change="changeDescription()" v-model="workOrder.solutionCode" filterable placeholder="Select a Solution Code">
                  <el-option
                    v-for="solution in orderBy(solutionCodes, 'description', 1)"
                    v-if="solution.department == workOrder.department"
                    :label="solution.description + ' (' + solution.solutionCode + ')'"
                    :value="solution.solutionCode">
                  </el-option>
                </el-select>
              </div>
                
              <div class="form-group">
                <label for="repairdescription">Description of Repairs / Field Notes</label>
                <textarea class="form-control" v-model="workOrder.repairsDescription"></textarea>
              </div>

              <div v-if="workOrder.solutionCode">
                <div class="form-group">
                  <button v-on:click="close()" type="button" class="btn mcBG scBGHover">Complete & Close WO</button>
                </div>     
              </div>

             </div>
           </div>
        </div>
        <!-- Form to Close the WO END -->   

        <!-- Completed Work Order Info START 
        [[ The following information is only shown if the Work Order is marked as completed. (workOrder.fieldComplete == true) ]] -->
        <div v-if="workOrder.fieldComplete">
          <h2>This Work Order is Closed</h2>
          <ul class="innerWOListing">
          <li><strong class="scText">Solution:</strong> <span class="inline-block" v-for="solution in solutionCodes" v-if="solution.solutionCode == workOrder.solutionCode">
          {{solution.description}}</span></li>
          <li><strong>Solution Code:</strong> {{workOrder.solutionCode}} </li>
          <li><strong>Completed Date:</strong> {{workOrder.completeDate | moment("MMM Do, YYYY") }} </li>
          <li><strong>Description of Repairs:</strong> {{workOrder.repairsDescription}} </li>
          </ul>
        </div>      
        <!-- Completed Work Order Info END -->

      </div>
      
      <!-- Mobile Bottom BAR START 
      [[ This lists the number of LEMs and allows you to go to each page to post/view them ]] -->  
      <div class="mobileBottomBar">
        <div class="container">
          <div class="row">
            <div class="col-xs-4" v-on:click="enterLabor()">
              Labor <span class="mcText">({{ laborRecords.length }})</span>
            </div>
            <div class="col-xs-4 center" v-on:click="enterEquipment()">
              Equipment <span class="mcText">({{ equipRecords.length }})</span>
            </div>
            <div class="col-xs-4" v-on:click="enterMaterial()">
              Materials <span class="mcText">({{ materialRecords.length }})</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Bottom BAR END -->

</div>
<!-- Main Mobile View END --> 

  <pre v-show="false">
    {{ $data }}
  </pre>
    
    
  </div>
</template>

<script>
import Store from '../store'
import User from '../services/user'
import { getWOConfigs } from '../services/padre.js';
import { getWorkOrder, getSolutionCodes, putWorkOrder, getMaterial, getLabor, getEquipment, getPhoto, getNotes } from '../services/requests'
import { BasicSelect } from 'vue-search-select'

export default {
  name: 'workorder',
  created() {

    this.savedEmployeeCode = localStorage.getItem("currentUserCode")

    this.username = User.getUsername()

    this.busy = true
    // get the work order by the number.

    this.workOrder = this.$route.params.id
   

    getMaterial(this.workOrder)
      .toArray((materialRecords) => {
        this.materialRecords = materialRecords
      })
    
    getPhoto(this.workOrder)
      .toArray((photoRecords) => {
        this.photoRecords = photoRecords
      })
    
    getNotes(this.workOrder)
      .toArray((notesRecords) => {
        this.notesRecords = notesRecords
      })

    getLabor(this.workOrder)
      .toArray((laborRecords) => {

        this.laborRecords = laborRecords
      })
  
      getEquipment(this.workOrder)
      .toArray((equipRecords) => {
        this.equipRecords = equipRecords

      })


      getWorkOrder(this.$route.params.id)
          .toArray((workOrders) => {
            // console.info(workOrders)
            
            this.workOrder = workOrders[0]

            // Set phone number as a callable link
            document.getElementById("link").setAttribute("href","tel:" + this.workOrder.phone);

              getSolutionCodes()
              .stopOnError((err) => {
                alert('Could not receive solution codes: ' + err)
              })

              .toArray((codes) => {
                this.busy = false,
                this.solutionCodes = codes

               if (this.workOrder.solutionCode == '0') {
                  this.workOrder.solutionCode = ''
               }
                
              })



          }
        )


    

  },
  components: {
    BasicSelect
  },
  methods: {


    backToListings() {
      this.$router.push('/')
    },
    logout() {
      User.logout()
      this.$router.replace('/login')
      alert('You have succesfully logged out!')
    },
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },
    enterLabor() {
      this.$router.push('/workOrder/labor/' + this.$route.params.id)
    },
    enterEquipment() {
      this.$router.push('/workOrder/equipment/' + this.$route.params.id)
    },
    enterMaterial() {
      this.$router.push('/workOrder/material/' + this.$route.params.id)
    },
    enterPhoto() {
      this.$router.push('/workOrder/photos/' + this.$route.params.id)
    },
    enterNotes() {
      this.$router.push('/workOrder/notes/' + this.$route.params.id)
    },
    openWOcloseForm() {
      this.openWOform = true;

    },
    changeDescription() {

        this.solutionCodes.forEach((solution) => {
          if (solution.solutionCode === this.workOrder.solutionCode) {
            this.workOrder.repairsDescription = solution.defaultComment 
          }
        })



    },
    update() {
      putWorkOrder(this.$route.params.id, this.workOrder)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)

        })
        .done(() => {
         //  this.$router.push('/')
        })
    },
    close() {

      this.$validator.validateAll().then(() => {
          let now = new Date()
          this.workOrder.completeDate = now.toISOString()
          console.log('Complete Date = ' + this.completeDate)

          this.workOrder.fieldComplete = true

          console.log(JSON.stringify(this.workOrder))
          
          putWorkOrder(this.$route.params.id, this.workOrder)
            .stopOnError((err) => {
              
              var errorArray = JSON.parse(err.message)
              this.errorArray = errorArray
              alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)
              
            })
            .done(() => {
              
          this.$router.push('/')
            })
          })
      }
  },
  data () {
   return {
      savedEmployeeCode: '',
        options: [],
                      item: {
                value: '',
                text: ''
              },
        
      laborRecords: [],
      materialRecords: [],
      photoRecords: [],
      notesRecords: [],
      equipRecords: [],
      materials: [],
      solutionCodes: [
      ],
      edits: {
      },
      workOrder: {
      },
      busy: true,
      openMenu: false,
      solutionId: '',
      openWOform: false,
      canUsePhotos: false
    }
  },
  async beforeMount() {
    let woConfigs = await getWOConfigs();

    this.canUsePhotos = woConfigs.canUsePhoto;
    console.log("this.canUsePhotos", this.canUsePhotos)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.closeWorkOrderContainer {
  position: relative;
}

  .closeWorkOrderContainer .top,
  .innerWoCompletion .top {
    z-index: 2;
    background: rgba(255,255,255,0.8);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  }

.validation-error {
    color: #cc0000;
    display: block;
    font-size: 11px;
    font-family: 'open_sanssemibold';
    margin-top: 3px;
}

.workorder {
    padding-top: 102px;
    position: relative;
    padding-bottom: 59px;
}

.mobileBottomBar {
    display: none;
}

.workorder .main-header {
    padding: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
}

.workorder .main-header .top {
    background: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
}

.workorder .header-btn {
    color: #fff;
    font-family: 'open_sanssemibold';
    font-size: 12px;
    margin-left: 10px;
}

.workorder .header-btn i {
    margin-right: 5px;
}

.tablet-view {
    padding-bottom: 30px;
    padding-top: 30px;
}

.tablet-view .form-group {
    margin: 15px 0;
    padding: 0 20px;
}

.tablet-view .form-group .form-control {
    background: #eef2f4;
    color: #666;
    font-size: 13px;
}

.tablet-view .form-group .btn {
    color: #fff;
    display: block;
    font-family: 'open_sansbold';
    font-size: 14px;
    font-weight: normal;
    margin: 0 auto;
    padding: 5px 15px;
    text-transform: uppercase;
}

.innerWOListing,
.innerWOListing li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.innerWOListing li {
    color: #010101;
    padding: 12px 10px 12px 20px;
}

.innerWOListing li:nth-of-type(even) {
    background: #f9f9f9;
}

.innerWOListing li strong {
    display: inline-block;
    font-family: 'open_sansbold';
    font-weight: normal;
    text-transform: uppercase;
}

.innerWOActions,
.innerWOActions li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.innerWOActions {
    margin-bottom: 20px;
}

.innerWOActions li {
    color: #010101;
    cursor: pointer;
    font-size: 18px;
    padding: 15px 10px 15px 20px;
}

.innerWOActions li i {
    color: #666;
    margin-right: 10px;
}

.innerWOActions li:hover {
     
}

.innerWOActions li:nth-of-type(odd) {
    background: #f9f9f9;
}

.loadingWorkOrders {
    font-size: 17px;
    font-family: 'open_sanssemibold';
    padding-top: 20px;
    text-align: center;
}

.loadingWorkOrders img {
    display: block;
    margin: 0 auto 10px;
}

#woListing {
    width: 100%;
}

#woListing ul,
#woListing ul li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 100%;
}

#woListing ul li {
    background-image: url(../../static/img/icon-wo-open.png);
    background-repeat: no-repeat;
    background-position: 15px center;    
    border-left: 8px solid #032a59;
    cursor: pointer;
    padding: 10px 0 10px 50px;
}

#woListing ul li.priorityHigh {
    border-left: 8px solid #cc0000;
}

#woListing ul li.priorityScheduled {
    border-left: 8px solid #66cc00;
}

#woListing ul li.priorityMedium {
    border-left: 8px solid #ff9900;
}

#woListing ul li .woTopRow {
    font-size: 16px;
}
  
#woListing ul li:nth-child(odd) {
    background-color: #eaeaea;
}

#woListing ul li strong {
    font-family: 'open_sansbold';
    font-weight: normal;
}

#woListing ul li img {
    padding-top: 30px;
}

.tablet-view {
    background: #f5f8fb;
}

.flexrow {
    display: flex;
}

.tablet-view .tabletSortSearchRow {
    font-family: 'open_sanssemibold';
    font-size: 12px; 
    padding-bottom: 15px;
    padding-top: 15px;
}

.tablet-view .tabletSortSearchRow a {
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    display: inline-block;
    margin: 0 0 5px;
    padding: 3px 10px;
    text-decoration: none;
}

.tablet-view .tabletSortSearchRow a.active {
    color: #fff;
}

.tablet-view .tabletSortSearchRow .form-control {
    background-color: #e7edf2;
    border: 0;
    display: inline-block;
    font-size: 12px;
    height: 26px;
    margin-left: 10px;
    max-width: 70%;
}

.tablet-view .tabletSortSearchRow .btn {
    color: #fff;
    max-width: 10%;
}

.tablet-view .inner {
    background: #fff;
    min-height: 100%;
}

.tablet-view .inner-dark {
    background: #212121;
    color: #fff;
    min-height: 100%;
    padding: 5px;
    text-align: center;
}

.tablet-view .inner-dark h3 {
    border-top: #555 solid 2px;
    border-bottom: #555 solid 2px;
    font-family: 'open_sanssemibold';
    font-size: 16px; 
    margin: 0;
    padding: 10px 0;
}

.tablet-view .inner-dark h3 span {
    color: #777;
    display: block;
    font-size: 11px;
    margin-bottom: 5px;
    text-transform: uppercase;
}

.tablet-view .inner-dark ul,
.tablet-view .inner-dark ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: right;
}

.tablet-view .inner-dark ul {
    padding-top: 10px;
    padding-right: 20px;
}

.tablet-view .inner-dark ul li {
    color: #fff;
    cursor: pointer;
    padding: 10px 0;
}

.tablet-view .inner-dark ul li i {
    color: #999;
    margin-left: 5px;
}

.tablet-view h2 {
    border-bottom: 1px solid #ccc;
    font-family: "ralewayblack";
    font-size: 20px;
    margin: 0;
    padding: 20px;
    text-transform: uppercase;
}

.tablet-view .completedtrue {
    background-image: none !important;
    border: 0 !important;
    padding: 10px 0 10px 10px !important;
}

.tablet-view .completedtrue:nth-child(odd) {
    background-color: #f3fbff !important;
}

.mobile-view .completedtrue {
    background: #333 !important;
    border-bottom: 1px dotted #666;
    color: #ccc;
}

.mobile-view .completedtrue .woTopRow {
    color: #fff;
}

.mobile-view h2 {
    border-bottom: 1px solid #ccc;
    font-family: "ralewayblack";
    font-size: 20px;
    margin: 0;
    padding: 10px;
    text-align: center;
    text-transform: uppercase;
}

.full-box {
    background: #fff;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    top: 0;
    z-index: 5;
}

.full-box .loadingWorkOrders {
    margin-top: 100px;
}

.full-box .main-logo {
    max-width: 150px;
}

.form-control.form-control-bigger {
    height: 50px;
}

.el-select {
    font-size: 12px;
    width: 100%;
}

.popClass {
    font-size: 12px;
    max-width: 100%;
}

#pickedSolutionCodeText {
    display: none;
}

@media only screen and (max-width : 768px) {

  .innerWOActions {
    margin-bottom: 00px;
    text-align: center;
}

    .innerWOtopRow {
        text-align: center;
    }

    .innerWOtopRow .row {
        display: flex;
        font-family: 'open_sanssemibold';
        font-size: 16px;
    }

    .innerWOtopRow .left {
        background: #e7e7e7;
        border-bottom: #d4d1d1 solid 4px;
        padding-bottom: 15px;
        padding-top: 15px;
    }

    .innerWOtopRow .right {
        padding-bottom: 15px;
        padding-top: 15px;
    } 

    .innerWOtopRow h5 {
        color: #999;
        font-size: 12px;
        margin: 0;
        padding: 0 0 5px 0;
        text-transform: uppercase;
    }

    .innerWOtopRow .right h5 {
        color: #e9e9e9;
    }

    .innerWOmainListing {
        font-size: 14px;
        margin: 8px 0px;
        text-align: center;
    } 

    .innerWOmainListing p {
        margin: 0 0 3px;
        padding: 0 5px;
    }

    .innerWOmainListing strong {
        font-family: 'open_sanssemibold';
        font-weight: normal;
    }

    .innerWOmainListing p.priorityHigh {
        background: #cc0000;
        color: #fff;
        font-family: 'open_sanssemibold';
        padding: 5px;
    }

    .innerWOmainListing p.priorityMedium {
        background: #ff9900;
        color: #fff;
        font-family: 'open_sanssemibold';
        padding: 5px;
    }

    .innerWOmainListing p.priorityScheduled {
        background: #66cc00;
        color: #fff;
        font-family: 'open_sanssemibold';
        padding: 5px;
    }

    .innerWoCompletion {
        background: #f8f8f8;
        padding: 25px;
        position: relative;
    }

    .innerWoCompletion .form-group .form-control {
        background: #eef2f4;
        font-size: 13px;
        color: #666;
    }

    .innerWoCompletion .form-group .btn {
        color: #fff;
        display: block;
        font-family: 'open_sansbold';
        font-size: 14px;
        font-weight: normal;
        margin: 0 auto;
        padding: 5px 15px;
        text-transform: uppercase;
    }

    #woListing ul li img {
        padding-top: 40px;
    }

    #woListing ul li {
        background-position: 10px center;
        font-size: 11px;
        padding: 10px 0 10px 30px;
    }

    #woListing ul li .woTopRow {
        font-size: 13px;
    }

    #woListing ul li.completedtrue {
        background-color: #333 !important;
        background-image: url(../../static/img/icon-wo-closed.png) !important;
        background-position: 10px center !important;
        background-repeat: no-repeat !important;
        border-left: 8px solid #006600 !important;
    }

    #woListing ul li.priorityHigh {
        border-left: 8px solid #cc0000 !important;
    }

    #woListing ul li.priorityScheduled {
        border-left: 8px solid #66cc00 !important;
    }

    #woListing ul li.priorityMedium {
        border-left: 8px solid #ff9900 !important;
    }

    .mobileBottomBar {
        background: #fff;
        bottom: 0px;
        -webkit-box-shadow: 0px -3px 5px #666;
        -moz-box-shadow: 0px -3px 5px #666;
        box-shadow: 0px -3px 5px #666;
        color: #999;
        cursor: pointer;
        display: block;
        font-family: 'open_sanssemibold';
        font-size: 15px;
        padding-top: 00px;
        position: fixed;
        text-align: center;
        width: 100%;
        z-index: 2;
    }

    .mobileBottomBar .col-xs-4 {
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .mobileBottomBar .center {
        border-left: 2px solid #ddd;
        border-right: 2px solid #ddd;
    }

    .mobileBottomBar span {
        display: block;
        font-size: 12px;
    }

    .mobile-sort {
        background: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        left: 50%;
        max-width: 75%;
        min-width: 50%;
        padding: 10px;
        position: absolute;
        text-align: center;
        transform: translateX(-50%);
        top: 50px;
    }

    .mobile-sort h3 {
        color: #000;
        font-family: 'open_sansbold';
        margin: 15px 0 15px 0;
        padding: 0;
        text-transform: uppercase;
    }

    .mobile-sort p {
        border-bottom: 1px solid #ddd;
        display: block;
        margin: 0;
        padding: 10px 0;
    }

    .mobile-sort p:last-of-type {
        border-bottom: 0px;
    }

    .mobile-sort p a {
        color: #333;
        display: block;
        font-family: 'open_sanssemibold';
        text-decoration: none;
    }

    .mobile-sort p a.active {
        font-family: 'open_sansbold';
        text-transform: uppercase;
    }

    .mobile-search {
        background: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-family: 'open_sansbold';
        left: 50%;
        position: absolute;
        padding: 10px;
        text-align: center;
        top: 50px;
        transform: translateX(-50%);
        width: 90%;
    }

    .mobile-search h3 {
        color: #000;
        font-family: 'open_sansbold';
        margin: 15px 0 15px 0;
        padding: 0;
        text-transform: uppercase;
    }

    .mobile-search input {
        margin-bottom: 20px;
        text-align: center;
    }

    .mobile-search a.btn {
        color: #fff;
        font-family: 'open_sansbold' !important;
        font-size: 16px;
        text-transform: uppercase;
    }
}

.meter {
  display: inline-block;
}

  .meter input {
    width: 90px;
    display: inline-block;
    margin: 0 10px;
  }

  .meter button {
    margin: -2px 0 0 0 !important
  }

</style>



// WEBPACK FOOTER //
// WorkOrder.vue?036aedbc